import React, { useEffect } from "react";
import { warmVisible } from "@/lib/api";
import TrackCard from "@/components/TrackCard";
import { Pager, usePager } from "@/components/Pager";

export function TrackCollection({ tracks, config, testid, perPage = 8 }) {
  const pg = usePager(tracks, perPage);
  useEffect(() => { const t = setTimeout(() => warmVisible(pg.slice.filter((x) => !x.is_pista)), 400); return () => clearTimeout(t); }, [pg.slice]);
  return (
    <div data-testid={testid}>
      <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
        {pg.slice.map((t) => <TrackCard key={t.id} track={t} queue={tracks} config={config} />)}
      </div>
      <Pager {...pg} testid={`${testid || "collection"}-pager`} />
    </div>
  );
}
